<template>
  <div class="login-page">
    <div class="logo-box">
      <szn-logo
        title-color="rgba(255,255,255,.8)"
        sub-title-color="rgba(255,255,255,.6)"
      ></szn-logo>
    </div>
    <div class="login-panel">
      <div class="left"></div>
      <div class="from-panel">
        <login></login>
      </div>
    </div>
  </div>
</template>

<script>
import SznLogo from "@/components/Logo.vue";
import Login from "@/components/Login.vue";
export default {
  components: {
    SznLogo,
    Login
  },
  data() {
    return {
      
    };
  },
  created() {},

  mounted(){

  },
  methods:{
     isIE() { //ie?
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
            return true;
        }else{
          return false;
        }
    }
  }
};
</script>

<style lang="less" scoped>
.logo-box {
  position: absolute;
  left: 24px;
  top: 24px;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 24px;
}
.login-page {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("~@/assets/loginm.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  &::after {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    content: " ";
    z-index: -1;
  }
  .login-panel {
    border-radius: 8px;
    overflow: hidden;
    width: 1000px;
    height: 560px;
    background: rgba(255, 255, 255, 0.85);
    display: flex;
    .left {
      width: 560px;
      flex-shrink: 0;
      background-image: url("~@/assets/login.png");
      background-position: center;
      background-size: cover;
    }
    .from-panel {
      flex: 1;
      padding: 48px 24px;
      
    }
  }
}
</style>